export const horizontalBlocks = 7;
export const verticalBlocks = 6;
export const horizontalDivisions = 16;
export const verticalDivisions = 16;
export const verticalRatio = 1; // 0.767;

export const imgPath = 'static/img/';
